export enum DateTypeEnum {
  Date = 'date',
  Time = 'time',
}
